module.exports = __webpack_public_path__ + "static/media/visa-icon.2b69d809.svg";